import Cookies from 'js-cookie'

export const TokenKey = 'AuthorizationPC'
export const refreshTokenKey = 'refresh_token'
export const tokenExpiresKey = 'tokenExpires'
export const sessionNameKey = 'ColdSessionId'
export const popFlgKey = 'popFlg'

export function getToken() {
  const tokenExpires = getTokenExpires()
  const now = Date.now()
  if (now >= tokenExpires) {
    removeToken()
    removeTokenExpires()
    return ''
  } else {
    let token1 = Cookies.get(TokenKey)
    if ((token1 === 'undefined undefined') || (token1 === 'undefined')) {
      token1 = ''
    }
    let token2 = localStorage.getItem(TokenKey)
    if ((token2 === 'undefined undefined') || (token2 === 'undefined')) {
      token2 = ''
    }
    return token1 || token2
  }
}

export function setToken(token: any, expires: any) {
  Cookies.set(TokenKey, token, {
    expires: expires
  })
  localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  Cookies.remove(TokenKey)
  localStorage.removeItem(TokenKey)
}

export function getRefreshToken() {
  return Cookies.get(refreshTokenKey) || localStorage.getItem(refreshTokenKey)
}

export function setRefreshToken(refreshToken: string, expires = 30) {
  Cookies.set(refreshTokenKey, refreshToken, {
    expires
  })
  localStorage.setItem(refreshTokenKey, refreshToken)
}

export function removeRefreshToken() {
  Cookies.remove(refreshTokenKey)
  localStorage.removeItem(refreshTokenKey)
}

export function getTokenExpires() {
  const cookieValue = Cookies.get(tokenExpiresKey);
  const localStorageValue = localStorage.getItem(tokenExpiresKey);

  // 显式转换为数字
  const value = (!isNaN(Number(cookieValue)) ? Number(cookieValue) : NaN) || (!isNaN(Number(localStorageValue)) ? Number(localStorageValue) : NaN)

  return isNaN(value) ? 0 : value;
}

export function setTokenExpires(tokenExpires: string, expires = 15) {
  Cookies.set(tokenExpiresKey, tokenExpires, {
    expires
  })
  localStorage.setItem(tokenExpiresKey, tokenExpires)
}

export function removeTokenExpires() {
  Cookies.remove(tokenExpiresKey)
  localStorage.removeItem(tokenExpiresKey)
}

export function getSessionName() {
  return Cookies.get(sessionNameKey) || localStorage.getItem(sessionNameKey)
}

export function setSessionName(data: string, expires = 1) {
  Cookies.set(sessionNameKey, data, {
    expires
  })
  localStorage.setItem(sessionNameKey, data)
}

export function removeSessionName() {
  Cookies.remove(sessionNameKey)
  localStorage.removeItem(sessionNameKey)
}

export function removeAuth() {
  removeToken()
  removeRefreshToken()
  removeTokenExpires()
  removeSessionName()
}

export function setPopFlg(token: string, expires = 1000) {
  return Cookies.set(popFlgKey, token, {
    expires
  })
}

export function getPopFlg() {
  return Cookies.get(popFlgKey)
}

export function getCustomUserAgent() {
  return Cookies.get('userAgent')
}

export function clearCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g) // eslint-disable-line
  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.kevis.com
      document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString() // 清除当前域名下的，例如 .m.kevis.com
      document.cookie = keys[i] + '=0;path=/;domain=kevis.com;expires=' + new Date(0).toUTCString() // 清除一级域名下的或指定的，例如 .kevis.com
    }
  }
}
